export class Context {

    private active: boolean;
    private centerInternalId: string;
    private centerName: string;
    private internalId: string;
    private apiAccessToken: string;
    private apiSecret: string;
    private sessionName: string;

    constructor(active?: boolean, centerInternalId?: string, centerName?: string, internalId?: string, apiAccessToken?: string, apiSecret?: string, sessionName?: string, ) {
        this.active = active;
        this.centerInternalId = centerInternalId;
        this.centerName = centerName;
        this.internalId = internalId;
        this.apiAccessToken = apiAccessToken;
        this.apiSecret = apiSecret;
        this.sessionName = sessionName;
    }

    public get Active() {
        return this.active;
    }
    public get CenterInternalId() {
        return this.centerInternalId;
    }
    public get CenterName() {
        return this.centerName;
    }
    public get InternalId() {
        return this.internalId;
    }
    public get ApiAccessToken() {
        return this.apiAccessToken;
    }
    public get ApiSecret() {
        return this.apiSecret;
    }
    public get SessionName() {
        return this.sessionName;
    }
    public set Active(active) {
        this.active = active;
    }
    public set CenterInternalId(centerInternalId) {
        this.centerInternalId = centerInternalId;
    }
    public set CenterName(centerName) {
        this.centerName = centerName;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set ApiAccessToken(apiAccessToken) {
        this.apiAccessToken = apiAccessToken;
    }
    public set ApiSecret(apiSecret) {
        this.apiSecret = apiSecret;
    }
    public set SessionName(sessionName) {
        this.sessionName = sessionName;
    }
}
